import { mapState, mapGetters, mapActions, mapMutations } from 'vuex';
import actions from './actions';
import getters from './getters';
import mutations from './mutations';
import state from './state';

export const serviceComputed = {
	...mapState('processRegistrationStore', Object.keys(state)),
	...mapGetters('processRegistrationStore', Object.keys(getters))
};
export const serviceMethods = {
	...mapActions('processRegistrationStore', Object.keys(actions)),
	...mapMutations('processRegistrationStore', Object.keys(mutations))
};
